import { render, staticRenderFns } from "./CentrosCustosTable.vue?vue&type=template&id=453bdc45&scoped=true"
import script from "./CentrosCustosTable.vue?vue&type=script&lang=js"
export * from "./CentrosCustosTable.vue?vue&type=script&lang=js"
import style0 from "./CentrosCustosTable.vue?vue&type=style&index=0&id=453bdc45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453bdc45",
  null
  
)

export default component.exports